// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"63":"brandChannelV2","883":"brandChannel","978":"slug"}[chunkId] || chunkId) + "-legacy." + {"63":"9b38e1d6","543":"2560def1","883":"35d070f2","978":"b3beaaff"}[chunkId] + ".js";
};